import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  selectCommunityInvitationSearchSending,
  selectCommunityInvitationSearchSucceed,
  selectCommunityInvitationSearchUsers,
} from '../../../redux/communities/selectors/selectors';
import * as invitationUserToCommunity from '../../../redux/communities/invitationUserToCommunity';
import * as invitationUsersSearch from '../../../redux/communities/invitationUserSearch';
import SearchDialogImpl from '../../common/SearchDialog/SearchDialogImpl';

const mapStateToProps = state => ({
  users: selectCommunityInvitationSearchUsers(state),
  loading: selectCommunityInvitationSearchSending(state),
  succeed: selectCommunityInvitationSearchSucceed(state),
});

const mapDispatchToProps = {
  fetchUserList: invitationUsersSearch.actions.send,
  inviteUsers: invitationUserToCommunity.actions.send,
  clear: invitationUsersSearch.actions.clear,
};

const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ fetchUserList, communityId, inviteUsers }) => ({
    getUsers: payload => fetchUserList({ ...payload, communityId }),
    onCreate: candidateUserIds =>
      inviteUsers({ communityId, candidateUserIds }),
  })),
);

const InviteToCommunityModalImpl = ({ intl: { formatMessage }, ...rest }) => {
  return (
    <SearchDialogImpl
      searchPlaceholder={formatMessage({ id: 'messages.chat.searchAUser' })}
      defaultState={formatMessage({ id: 'community.menu.inviteDefault' })}
      emptyState={formatMessage({ id: 'messages.chat.noOneFound' })}
      buttonTitle={formatMessage({ id: 'community.menu.invite' })}
      title={formatMessage({ id: 'community.menu.invitePeople' })}
      defaultIcon="no-one-found"
      {...rest}
    />
  );
};

InviteToCommunityModalImpl.propTypes = {
  intl: PropTypes.object.isRequired,
};

export const InviteToCommunityModal = enhance(InviteToCommunityModalImpl);



// WEBPACK FOOTER //
// ./src/components/Community/InviteToCommunityModal/index.jsx